module.exports = __webpack_public_path__ + "static/media/2.f6d85621.png";